import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFamiliesChartsDataContext } from './hooks/useFamiliesChartsDataContext';

export const People = () => {
    const { chartData } = useFamiliesChartsDataContext();


    return (
        <SimpleBars
            title={'Total de Pessoas'}
            horizontal={true}
            subtitles={chartData?.people?.map((item) => item.description)}
            values={chartData?.people?.map((item) => item.total  ||  0)}
            height={400}
        />
    );
};
